export default __webpack_public_path__ + "static/media/cold.1adc48b7.jpg";